export default __webpack_public_path__ + "static/media/SL.fe74d319.svg";